import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
import { Icon } from '../Icon';
export const TextArea = forwardRef(({ name, label, disabled, size, id, helper, isSuccess, errors, value, className, dataTestId, labelDirection = 'col', ...defaultTextareaProps }, ref) => {
    const wrapperClassName = classNames(`flex flex-${labelDirection}`, {
        'gap-1 md:gap-2': !size,
        'gap-1': size === 'sm',
        'gap-2': size === 'md' || size === 'lg'
    }, className);
    const labelClassName = classNames('min-w-[120px] font-semibold', disabled ? 'text-gray' : 'text-gray-700', {
        'text-mBase md:text-base': !size,
        'text-sm': size === 'sm',
        'text-base': size === 'md',
        'text-mBase': size === 'lg'
    });
    const textareaWrapperClassName = 'relative w-full leading-none';
    const textareaClassName = classNames('w-full resizer-none outline-none ring-1 border-none rounded-md placeholder-gray text-gray-700 disabled:ring-gray-200 disabled:bg-gray-200 disabled:text-gray resize-y px-3 focus:shadow-none focus:ring-2 focus:ring-blue', {
        'bg-green-50': isSuccess
    }, {
        'text-mBase py-[13px] md:text-base md:py-[9px]': !size,
        'text-sm py-2': size === 'sm',
        'text-base py-[9px]': size === 'md',
        'text-mBase py-[13px]': size === 'lg'
    }, !errors ? 'ring-gray-400 shadow-sm' : 'ring-2 ring-red shadow-none');
    const helperClassName = classNames('mt-2', {
        'text-base md:text-sm': !size,
        'text-xs': size === 'sm',
        'text-sm': size === 'md',
        'text-base': size === 'lg'
    }, !!errors ? 'text-red' : 'text-gray');
    const draggerClassName = classNames('absolute right-0 bottom-0 w-4 h-4 pointer-events-none text-gray-400');
    const postIconClassName = classNames('absolute right-3', {
        'w-6 h-6 top-[13px] md:w-5 md:h-5 md:top-[9px]': !size,
        'w-4 h-4 top-[8.5px]': size === 'sm',
        'w-5 h-5 top-[9px]': size === 'md',
        'w-6 h-6 top-[13px]': size === 'lg'
    }, errors ? 'text-red' : isSuccess ? 'text-green' : 'text-gray');
    const helperWrapperClassName = 'w-full';
    return (_jsxs("div", { className: wrapperClassName, children: [label && (_jsx("label", { className: labelClassName, htmlFor: id, children: label })), _jsxs("div", { className: helperWrapperClassName, children: [_jsxs("div", { className: textareaWrapperClassName, children: [_jsx("textarea", { ...defaultTextareaProps, className: textareaClassName, "data-testid": dataTestId, disabled: disabled, id: id, name: name, ref: ref, value: value }), _jsx(Icon, { className: draggerClassName, name: "dragger" }), (errors || isSuccess) && (_jsx(Icon, { className: postIconClassName, name: errors ? 'error' : 'check-circle' }))] }), helper && _jsx("div", { className: helperClassName, children: helper })] })] }));
});
TextArea.displayName = 'CommonTextArea';
